import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Step, StepType } from '../../types/steps.type';
import { AiFeedbackStep } from '../../types/steps/ai-feedback-step.interface';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { hasVisibleText } from '../../../../shared/utils/has-visible-text.util';

@Component({
  selector: 'ai-feedback-inputs',
  standalone: false,
  templateUrl: './ai-feedback-inputs.component.html',
  styleUrl: './ai-feedback-inputs.component.scss'
})
export class AiFeedbackInputsComponent implements OnInit {
  @Input() step: Step | null = null;
  @Input() currentLang!: string;
  // Whether the free-text answer has anything visible to send
  @Output() textAnswerValidityChange = new EventEmitter<boolean>();
  inputValue: string = '';
  feedbackType: 'textarea' | 'checkbox' | null = null;
  feedbackStep: AiFeedbackStep | null = null;
  checkedOptions: string[] = [];
  ngOnInit(): void {
    if (this.step && this.step.type === StepType.AI_FEEDBACK) {
      this.feedbackStep = this.step as AiFeedbackStep;
      this.feedbackType = this.step.feedback_type || 'textarea';
    }
  }
  onValueChange(newValue: string): void {
    this.inputValue = newValue;
    if (this.feedbackStep) {
      this.feedbackStep.api.data.user_prompt = this.inputValue.trim();
    }
    this.textAnswerValidityChange.emit(hasVisibleText(this.inputValue));
  }
  onCheckboxChange(event: MatCheckboxChange, option: { [key: string]: any }) {
    const label = option['message'][this.currentLang];
    if (event.checked) {
      if (!this.checkedOptions.includes(label)) {
        this.checkedOptions.push(label);
      }
    } else {
      this.checkedOptions = this.checkedOptions.filter((opt) => opt !== label);
    }
    if (this.feedbackStep) {
      this.feedbackStep.api.data.user_prompt = this.checkedOptions.join(', ');
    }
  }
}
